export default __webpack_public_path__ + "static/media/PhonePe.fef1950d.png";